(function () {
  if (window.__cardSwatchHoverInit) return;
  window.__cardSwatchHoverInit = true;

  function getMainImage(swatchEl) {
    var wrapper = swatchEl.closest('.card-wrapper');
    if (!wrapper) return null;
    return wrapper.querySelector('.card__media img.motion-reduce');
  }

  function showSwatchImage(event) {
    var swatch = event.target.closest('.card-swatch[data-swatch-image]');
    if (!swatch) return;
    var img = getMainImage(swatch);
    if (!img) return;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
    }

    img.setAttribute('src', swatch.getAttribute('data-swatch-image'));
    img.setAttribute('srcset', '');
  }

  function restoreOriginalImage(event) {
    var swatch = event.target.closest('.card-swatch[data-swatch-image]');
    if (!swatch) return;

    var related = event.relatedTarget;
    if (related && swatch.contains(related)) return;

    var img = getMainImage(swatch);
    if (!img || !img.dataset.originalSrc) return;

    img.setAttribute('src', img.dataset.originalSrc);
    img.setAttribute('srcset', img.dataset.originalSrcset);
  }

  document.addEventListener('mouseover', showSwatchImage);
  document.addEventListener('mouseout', restoreOriginalImage);
  document.addEventListener('focusin', showSwatchImage);
  document.addEventListener('focusout', restoreOriginalImage);
})();
